export const externalConfig = {
  externalapihost:
    process.env.REACT_APP_EXTERNALRESTAPI_HOST ||
    process.env.NODE_HOST ||
    'enhancer.lbl.gov',
  externalapiport: Number(process.env.REACT_APP_EXTERNALRESTAPI_PORT) || 80,
  curationapihost:
    process.env.REACT_APP_CURATION_RESTAPI_HOST ||
    process.env.NODE_HOST ||
    'enhancer.lbl.gov',
  curationapiport: Number(process.env.REACT_APP_CURATION_RESTAPI_PORT) || 80,
};

const buildApiUrl = (host, port) => {
  const protocol = port === 80 ? 'http://' : 'https://';
  const isDefaultPort = port === 80 || port === 443;
  return `${protocol}${host}${isDefaultPort ? '' : `:${port}`}/vista_api`;
};

export const apiUrl = buildApiUrl(
  externalConfig.externalapihost,
  externalConfig.externalapiport
);

export const curationApiUrl = buildApiUrl(
  externalConfig.curationapihost,
  externalConfig.curationapiport
);
